const o = "abort", t = "signal is aborted without reason";
export {
  o as ABORT_EVENT,
  t as DEFAULT_ABORT_ERROR_MESSAGE
};
